import React, { useEffect, useState } from "react";

const API = "https://api.getfitindia.in/api/admin/courtowners";

export default function CourtOwnerApprovals() {
  const [list, setList] = useState([]);      // pending
  const [others, setOthers] = useState([]);  // rejected

  const loadPending = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await fetch(`${API}/pending`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = await res.json();

      if (!res.ok) {
        alert(data.error || "Unauthorized");
        return;
      }

      setList(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  const loadAll = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await fetch(`${API}/all`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = await res.json();

      if (res.ok && Array.isArray(data)) {
        // only rejected
        setOthers(data.filter((o) => o.status === "rejected"));
      }
    } catch (err) {
      console.error("Error loading full list", err);
    }
  };

  const handleApprove = async (id) => {
    const token = localStorage.getItem("token");

    const res = await fetch(`${API}/approve/${id}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    const data = await res.json();

    if (res.ok) {
      alert("Approved!");
      loadPending();
      loadAll();
    } else alert(data.error || "Failed");
  };

  const handleReject = async (id) => {
    const token = localStorage.getItem("token");

    const res = await fetch(`${API}/reject/${id}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    const data = await res.json();

    if (res.ok) {
      alert("Rejected!");
      loadPending();
      loadAll();
    } else alert(data.error || "Failed");
  };

  useEffect(() => {
    loadPending();
    loadAll();
  }, []);

  return (
    <div className="min-h-screen bg-[#F5F7FB]">
      {/* Top dark bar similar to your screenshots */}
   <div className="bg-[#0f2250] text-white sticky top-0 z-20">
        <div className="max-w-6xl  px-4 py-4">
       <h1 className="text-lg font-semibold ms-12 sm:ms-0 mt-1">
 Court Owner Approvals
</h1>

        </div>
      </div>

      <div className="flex-1 px-3 sm:px-5 lg:px-10 py-4 overflow-y-auto">
        {/* ========= PENDING TABLE ========= */}
        <div className="bg-white rounded-2xl shadow-md border border-[#E6EBF2] overflow-hidden">
          {/* Header strip like “Users List / Total: 15” */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 px-6 py-4 bg-[#F5F8FF] border-b border-[#E6EBF2]">
            <div>
              <p className="text-sm text-gray-500">Pending Court Owners</p>
              <h2 className="text-base sm:text-lg font-semibold text-[#0C295F]">
                New Registration Requests
              </h2>
            </div>
            <div className="text-xs sm:text-sm text-gray-600">
              Total:{" "}
              <span className="font-semibold text-[#0C295F]">
                {list.length}
              </span>
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-[#E5EDFF] text-[#0C295F]">
                <tr>
                  <th className="px-6 py-3 text-left font-semibold">#</th>
                  <th className="px-6 py-3 text-left font-semibold">Name</th>
                  <th className="px-6 py-3 text-left font-semibold">Mobile</th>
                  <th className="px-6 py-3 text-left font-semibold">Email</th>
                  <th className="px-6 py-3 text-left font-semibold">
                    Business
                  </th>
                  <th className="px-6 py-3 text-left font-semibold">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {list.length === 0 && (
                  <tr>
                    <td
                      colSpan={6}
                      className="px-6 py-6 text-center text-gray-500"
                    >
                      No pending requests.
                    </td>
                  </tr>
                )}

                {list.map((o, idx) => (
                  <tr
                    key={o._id}
                    className={
                      idx % 2 === 0 ? "bg-white" : "bg-[#F8FAFF]"
                    }
                  >
                    <td className="px-6 py-3">{idx + 1}</td>
                    <td className="px-6 py-3">{o.name || "N/A"}</td>
                    <td className="px-6 py-3">{o.mobile}</td>
                    <td className="px-6 py-3">{o.email}</td>
                    <td className="px-6 py-3">
                      {o.businessName || "N/A"}
                    </td>
                    <td className="px-6 py-3">
                      <div className="flex flex-wrap gap-2">
                        <button
                          onClick={() => handleApprove(o._id)}
                          className="px-4 py-1.5 rounded-full text-xs sm:text-sm font-semibold bg-[#10B981] hover:bg-[#059669] text-white shadow-sm"
                        >
                          Approve
                        </button>
                        <button
                          onClick={() => handleReject(o._id)}
                          className="px-4 py-1.5 rounded-full text-xs sm:text-sm font-semibold bg-[#EF4444] hover:bg-[#DC2626] text-white shadow-sm"
                        >
                          Reject
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* ========= REJECTED TABLE ========= */}
        <div className="bg-white rounded-2xl shadow-[0_0_6px_rgba(0,0,0,0.2)] border border-[#E6EBF2] overflow-hidden mt-8">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 px-6 py-4 bg-[#F5F8FF] border-b border-[#E6EBF2]">
            <h2 className="text-base sm:text-lg font-semibold text-[#0C295F]">
              Rejected Requests
            </h2>
            <div className="text-xs sm:text-sm text-gray-600">
              Total:{" "}
              <span className="font-semibold text-[#0C295F]">
                {others.length}
              </span>
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-[#E5EDFF] text-[#0C295F]">
                <tr>
                  <th className="px-6 py-3 text-left font-semibold">#</th>
                  <th className="px-6 py-3 text-left font-semibold">Name</th>
                  <th className="px-6 py-3 text-left font-semibold">Mobile</th>
                  <th className="px-6 py-3 text-left font-semibold">Email</th>
                  <th className="px-6 py-3 text-left font-semibold">
                    Business
                  </th>
                  <th className="px-6 py-3 text-left font-semibold">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {others.length === 0 && (
                  <tr>
                    <td
                      colSpan={6}
                      className="px-6 py-6 text-center text-gray-500"
                    >
                      No rejected requests yet.
                    </td>
                  </tr>
                )}

                {others.map((o, idx) => (
                  <tr
                    key={o._id}
                    className={
                      idx % 2 === 0 ? "bg-white" : "bg-[#F8FAFF]"
                    }
                  >
                    <td className="px-6 py-3">{idx + 1}</td>
                    <td className="px-6 py-3">{o.name}</td>
                    <td className="px-6 py-3">{o.mobile}</td>
                    <td className="px-6 py-3">{o.email}</td>
                    <td className="px-6 py-3">{o.businessName}</td>
                    <td className="px-6 py-3">
                      <span className="inline-flex px-3 py-1 rounded-full text-xs font-semibold bg-red-100 text-red-700">
                        Rejected
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
